var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImagePanelIcon = function SvgImagePanelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 52,
    fill: "none",
    viewBox: "0 0 64 52"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E5E5FE",
    fillRule: "evenodd",
    d: "M24.78 24.67a1 1 0 0 0-1.428.128L3.712 48.967 5.5 50.5l2.5 1h46.794a.99.99 0 0 0-.226-1.24z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    fillRule: "evenodd",
    d: "M25.106 24.29a1.5 1.5 0 0 0-2.142.192L3.332 48.642l.76.65 19.648-24.18a.5.5 0 0 1 .714-.063l29.789 25.59a.501.501 0 0 1-.186.861h1.28a1.47 1.47 0 0 0-.443-1.619z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F9F9FA",
    d: "M8 13a6 6 0 0 1 12 0 6 6 0 0 1-12 0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    fillRule: "evenodd",
    d: "M7.5 13a6.5 6.5 0 1 1 13 0 6.5 6.5 0 0 1-13 0M14 7.5a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F7FA",
    fillRule: "evenodd",
    d: "M45.11 19.621a1 1 0 0 0-1.619-.01l-22.63 30.816a.99.99 0 0 0-.089 1.038L57 51l3-1.5 2.5-3 .59-1.769z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    fillRule: "evenodd",
    d: "M45.517 19.33a1.5 1.5 0 0 0-2.429-.014L20.458 50.13c-.308.42-.359.912-.221 1.34l1.186-.015a.5.5 0 0 1-.159-.733l22.63-30.816a.5.5 0 0 1 .81.005l18.19 25.405.39-1.172z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#3D4355",
    fillRule: "evenodd",
    d: "M54 1H10a9 9 0 0 0-9 9v32a9 9 0 0 0 9 9h44a9 9 0 0 0 9-9V10a9 9 0 0 0-9-9M10 0C4.477 0 0 4.477 0 10v32c0 5.523 4.477 10 10 10h44c5.523 0 10-4.477 10-10V10c0-5.523-4.477-10-10-10z",
    clipRule: "evenodd"
  })));
};
export default SvgImagePanelIcon;